// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { FormModel, SetFormHandlerParameter } from "@store/Framework/Store/Foundation/Components/Form/FormTypes";

type FormComponentState = Toolkit.Store.Foundation.Components.Form.State;

const initialState: FormComponentState = {
    forms: [],
};

const actions = {
    "Foundation/Components/Form/SetForm": (
        state: FormComponentState,
        action: { parameter: SetFormHandlerParameter },
    ): FormComponentState => {
        const newForm = {
            id: action.parameter.formId,
            inputs: [],
            hasAlreadyError: false,
        };

        return {
            forms: [...state.forms, newForm],
        };
    },
    "Foundation/Components/Form/DestroyForm": (
        state: FormComponentState,
        action: { parameter: SetFormHandlerParameter },
    ): FormComponentState => {
        const filteredFormsList = state.forms.filter(x => x.id !== action.parameter.formId);

        return {
            forms: filteredFormsList,
        };
    },
    "Foundation/Components/Form/SetInput": (
        state: FormComponentState,
        action: { forms: FormModel[] },
    ): FormComponentState => {
        return {
            forms: action.forms,
        };
    },
    "Foundation/Components/Form/EmptyForm": (
        state: FormComponentState,
        action: { forms: FormModel[] },
    ): FormComponentState => {
        return {
            forms: action.forms,
        };
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type FoundationComponentsFormActions = Parameters<typeof reducer>[1];
export default reducer;
